var Comments = {
	node :null,
	isOpen: false,
	couting: null,

	init: function() {
		if (player.offline) return;
		
		Tab.setGroup("comments", "+");

		Comments.node = $(TPL.render("comments-main", {}));
		$("#panels").append(Comments.node);
		if (PROJECT.settings['comments/mode'] != "off") {
			this.createUI();
			//Comments.icon = Menu.prepIcon('fas fa-share-alt', TPL.lng("tips.share", "Udostępnij"), 'HTML5.tips.share', {"sub": 0, "subsel": ".items", "itemsel": "a", "toggle": Share.toggle, "node": this.node});
			AppEvent.on(player, "PLACE.LOADED", Comments.placeLoaded);
			Tab.add("bottom", Tab.simpleTab($(".commentbutton"), 10), {});
		}
		$("#cmnt-btn-latest").hide();
		$("#cmnt-btn-current").hide();

		Tab.add("comments", Tab.simpleTabInput($("#com_message"), 1), {});
		Tab.add("comments", Tab.simpleTabInput($("#com_author"), 5), {});
		Tab.add("comments", Tab.simpleTab(Comments.node.find(".send"), 20), {});		
		Tab.add("comments", Tab.simpleTab(Comments.node.find(".close"), 50), {});		

		Tab.groups["comments"].disable();
	},

	placeLoaded: function() {		
		var total;
		try {
			total = player.current.comments.count;
		} catch(e) {
			total = 0;
		}

		if (total > 0) Comments.button.find(".counter").html("(" + total + ")");
		else Comments.button.find(".counter").html("");
	},

	createUI: function() {
		var total;
		try {
			total = player.current.comments.count;
		} catch(e) {
			total = 0;
		}
		Comments.button = $("<a href='javascript:void(null);' aria-hidden='true' onclick='Comments.open();' class='commentbutton' data-speak='PLAYER.COMMENTS' data-speakgroup='TIPS' title='" + TPL.lng("comments_button", "Komentarze") + "'><i class='fas fa-comments'></i> " + TPL.lng("comments_button", "Komentarze") + " <span class='counter'>(" + total + ")</span>" + "</a>");
		
		if (!Screen.xs()) $("#overlay .tray").append(Comments.button);

		SpeechManager.enableSpeech("#overlay", ".commentbutton", 1, "TOPMENU");
	},

	startCounting: function() {
		if (Comments.counting == null) Comments.counting = setInterval(Comments.countingFunc, 300);
	},

	stopCounting: function() {
		if (Comments.counting != null) clearInterval(Comments.counting);
		Comments.counting = null;
	},

	countingFunc: function() {
		$(".comments .counter").html($(".comments #com_message").val().length + " / 500");
	},

	close: function() {
		Comments.node.hide();
		Comments.stopCounting();
		Tab.groups["comments"].disable();

		$("#player").css("width", "100%");
		$("#hmenu").css("width", "100%");
		$("#overlay").css("width", "100%");
		$("#ui").css("width", "100%");

		$(Comments).trigger("hide");

		player._width = $("#player").width();
		player._height = $("#player").height();
		
		setTimeout(function() {
			player.currentView.reorient();
		}, 200);
	},

	closeSendInfo: function() {
		$(".comments .com-added").hide();
		$(".comments .com-add").show();
	},

	preventKeys: function(evt) {
		evt.stopPropagation();
		return false;
	},

	open: function() {
		Comments.node.show();
		Comments.startCounting();
		Tab.groups["comments"].enable();

		$(".comments .com-add").show();
		$(".comments .com-list").removeClass("full");
		$(".comments .com-list").scrollTop(0);
		//$("#cmnt-btn-latest").show();
		$("#cmnt-btn-current").hide();

		$("#player").css("width", "calc(100% - 350px)");
		$("#hmenu").css("width", "calc(100% - 350px)");
		$("#overlay").css("width", "calc(100% - 350px)");
		$("#ui").css("width", "calc(100% - 350px)");

		player._width = $("#player").width();
		player._height = $("#player").height();

		$(Comments).trigger("shown");
		
		setTimeout(function() {
			player.currentView.reorient();
		}, 200);


		$("#no-comments").hide();
		$(".com-list").html("<div class='item'><i class='fas fa-spinner fa-spin'></i> Ładowanie ...</div>");

		ssi("comments","list",{"id":player.ident, "filter": "full"},function(resp) {
			
			//console.log(resp.data);
			$(".com-list").html("");
			$(".comments h3").html("Komentarze (" + resp.data.count + ")");
			if (resp.data.count > 0) {
				$("#no-comments").hide();
				for(var i in resp.data.items) {
					var item = resp.data.items[i];
					var rx = parseFloat(item.rx);
					var ry = parseFloat(item.ry) * -1;
					if (isNaN(rx)) rx = 0;
					if (isNaN(ry)) ry = 0;

					$(".com-list").append("<div class='item thumb'><div class='thumb' style='background-image: url(\"" + item.thumb_url + "\")' onclick='player.go(" + item.place + ", \"" + rx + "," + ry + "\");'></div><div class='author'>" + item.author + "</div>" + item.comment + "</div>");
				//	$(".com-list").append("<div class='item'><div class='author'>" + item.author + "</div>" + item.comment + "</div>");
//					$(".com-list").append("<div class='item'><i class='fas fa-comments'></i><div class='author'>" + item.author + "</div>" + item.comment + "</div>");
				}
			} else {
				$("#no-comments").show();
			}
		});
	},

	latest: function() {
		Comments.node.show();
		Comments.startCounting();

		$(".comments .com-add").hide();
		$(".comments .com-list").addClass("full");
		$(".comments .com-list").scrollTop(0);
		$("#cmnt-btn-latest").hide();
		$("#cmnt-btn-current").show();

		$(".com-list").html("<div class='item'><i class='fas fa-spinner fa-spin'></i> Ładowanie ...</div>");

		ssi("comments","list",{"id":player.ident, "filter": "full"},function(resp) {
			
			//console.log(resp.data);
			$(".com-list").html("");
			$(".comments h3").html("Wszystkie komentarze (" + resp.data.count + ")");
			if (resp.data.count > 0) {
				$("#no-comments").hide();
				for(var i in resp.data.items) {
					var item = resp.data.items[i];
					if (item.author == "") item.author = "Brak autora";
					$(".com-list").append("<div class='item thumb'><div class='thumb' style='background-image: url(\"" + item.thumb_url + "\")' onclick='player.go(" + item.place + ", \"0\");'></div><div class='author'>" + item.author + "</div>" + item.comment + "</div>");
				}
			} else {
				$("#no-comments").show();
			}
		});
	},

	add: function() {
		var c = $("#com_message").val();
		if (c.trim() == "") {
			$("#com_message").addClass("error");
			
			if (Comments.ferr != undefined) clearTimeout(Comments.ferr);

			Comments.ferr = setTimeout(function() {
				$("#com_message").removeClass("error");
				Comments.ferr = undefined;
			}, 1000);

		} else {
			$(".com-add").addClass("sending");
			$(".com-add .send").html('<i class="fas fa-spinner fa-spin"></i>');
			ssi("comments","add",{"id":player.ident, "comment": c, "author": $("#com_author").val()},function(resp) {
				$("#com_message").val("");
				$(".com-add").removeClass("sending");
				$(".com-add .send").html("Wyślij");

				$(".comments .com-added").show();
				$(".comments .com-add").hide();
			});
		}
	},

	placeReady: function(pe) {
	},
}

PluginManager.add(Comments);